const translations = {
    en: {
        mail_unsubscribe: {
          subscribed_title: 'You are currently subscribed to communications about this stay.',
          subscribed_subtitle: 'Do you want to unsubscribe?',
          subscribed_confirm: 'Yes, unsubscribe me',
          subscribed_cancel: 'No, I’ve changed my mind',
          unsubscribed_title: 'You are currently unsubscribed from communications about this stay.',
          unsubscribed_subtitle: 'Do you want to re-subscribe?',
          unsubscribed_confirm: 'Yes, re-subscribe me',
          unsubscribed_cancel: 'No, thank you',

          confirmation: {
            deactivate: {
              confirm: 'Thank you for updating your preferences. You will no longer receive communications related to this stay. If you change your mind, you can update your preferences at any time.',
              cancel: 'Thank you for your choice! We’re glad you’ve decided to stay in touch with us. You will continue to receive updates about your stay.'
            },
            activate: {
              confirm: 'Thank you for your choice! We’re glad you’ve decided to resubscribe to communications. You will continue to receive updates about your stay.',
              cancel: 'Thank you for updating your preferences. You will not receive communications related to this stay. If you change your mind, you can update your preferences at any time.'
            }
          }
        }
    },
    de: {
        mail_unsubscribe: {
          subscribed_title: 'Sie sind derzeit für Kommunikationen zu diesem Aufenthalt angemeldet.',
          subscribed_subtitle: 'Möchten Sie sich abmelden?',
          subscribed_confirm: 'Ja, melden Sie mich ab',
          subscribed_cancel: 'Nein, ich habe es mir anders überlegt',
          unsubscribed_title: 'Sie sind derzeit von den Kommunikationen zu diesem Aufenthalt abgemeldet.',
          unsubscribed_subtitle: 'Möchten Sie sich erneut anmelden?',
          unsubscribed_confirm: 'Ja, melden Sie mich erneut an',
          unsubscribed_cancel: 'Nein, danke',

          confirmation: {
            deactivate: {
              confirm: 'Vielen Dank, dass Sie Ihre Präferenzen aktualisiert haben. Sie werden keine Mitteilungen mehr zu diesem Aufenthalt erhalten. Sollten Sie Ihre Meinung ändern, können Sie Ihre Präferenzen jederzeit aktualisieren.',
              cancel: 'Vielen Dank für Ihre Entscheidung! Wir freuen uns, dass Sie weiterhin mit uns in Kontakt bleiben. Sie werden weiterhin Updates zu Ihrem Aufenthalt erhalten.'
            },
            activate: {
              confirm: 'Vielen Dank für Ihre Entscheidung! Wir freuen uns, dass Sie sich entschieden haben, unsere Kommunikation wieder zu abonnieren. Sie werden weiterhin Updates zu Ihrem Aufenthalt erhalten.',
              cancel: 'Vielen Dank, dass Sie Ihre Präferenzen aktualisiert haben. Sie werden keine Mitteilungen zu diesem Aufenthalt erhalten. Sollten Sie Ihre Meinung ändern, können Sie Ihre Präferenzen jederzeit aktualisieren.'
            }
          }
        }
    },
    es: {
        mail_unsubscribe: {
          subscribed_title: 'Actualmente estás suscrito a las comunicaciones sobre esta estancia.',
          subscribed_subtitle: '¿Quieres darte de baja?',
          subscribed_confirm: 'Sí, dame de baja',
          subscribed_cancel: 'No, he cambiado de opinión',
          unsubscribed_title: 'Actualmente estás dado de baja de las comunicaciones sobre esta estancia.',
          unsubscribed_subtitle: '¿Quieres volver a suscribirte?',
          unsubscribed_confirm: 'Sí, vuélveme a suscribir',
          unsubscribed_cancel: 'No, gracias',

          confirmation: {
            deactivate: {
              confirm: 'Gracias por actualizar tus preferencias. Ya no recibirás comunicaciones relacionadas con esta estancia. Si cambias de opinión, puedes actualizar tus preferencias en cualquier momento.',
              cancel: '¡Gracias por tu elección! Nos alegra que hayas decidido seguir en contacto con nosotros. Continuarás recibiendo actualizaciones sobre tu estancia.'
            },
            activate: {
              confirm: '¡Gracias por tu elección! Nos alegra que hayas decidido volver a suscribirte a las comunicaciones. Continuarás recibiendo actualizaciones sobre tu estancia.',
              cancel: 'Gracias por actualizar tus preferencias. No recibirás comunicaciones relacionadas con esta estancia. Si cambias de opinión, puedes actualizar tus preferencias en cualquier momento.'
            }
          }
        }
    },
    fr: {
        mail_unsubscribe: {
          subscribed_title: 'Vous êtes actuellement abonné aux communications concernant ce séjour.',
          subscribed_subtitle: 'Voulez-vous vous désabonner?',
          subscribed_confirm: 'Oui, désabonnez-moi',
          subscribed_cancel: 'Non, j’ai changé d’avis',
          unsubscribed_title: 'Vous êtes actuellement désabonné des communications par e-mail concernant ce séjour.',
          unsubscribed_subtitle: 'Voulez-vous vous réabonner?',
          unsubscribed_confirm: 'Oui, réabonnez-moi',
          unsubscribed_cancel: 'Non, merci',

          confirmation: {
            deactivate: {
              confirm: 'Merci d’avoir mis à jour vos préférences. Vous ne recevrez plus de communications relatives à ce séjour. Si vous changez d’avis, vous pouvez modifier vos préférences à tout moment.',
              cancel: 'Merci pour votre choix ! Nous sommes ravis que vous ayez décidé de rester en contact avec nous. Vous continuerez à recevoir des mises à jour concernant votre séjour.'
            },
            activate: {
              confirm: 'Merci pour votre choix ! Nous sommes ravis que vous ayez décidé de vous réinscrire aux communications. Vous continuerez à recevoir des mises à jour concernant votre séjour.',
              cancel: 'Merci d’avoir mis à jour vos préférences. Vous ne recevrez pas de communications relatives à ce séjour. Si vous changez d’avis, vous pouvez modifier vos préférences à tout moment.'
            }
          }

        }
    },
    it: {
        mail_unsubscribe: {
          subscribed_title: 'Sei attualmente iscritto alle comunicazioni relative a questo soggiorno.',
          subscribed_subtitle: 'Vuoi disiscriverti?',
          subscribed_confirm: 'Si, disiscrivimi',
          subscribed_cancel: 'No, ci ho ripensato',
          unsubscribed_title: 'Sei attualmente disiscritto dalle comunicazioni relative a questo soggiorno.',
          unsubscribed_subtitle: 'Vuoi reiscriverti?',
          unsubscribed_confirm: 'Si, reiscrivimi',
          unsubscribed_cancel: 'No, grazie',

          confirmation: {
            deactivate: {
              confirm: 'Grazie per aver aggiornato le tue preferenze, non riceverai più comunicazioni relative a questo soggiorno. Se dovessi cambiare idea, potrai sempre aggiornare le tue preferenze in qualsiasi momento.',
              cancel: 'Grazie per la tua scelta! Siamo lieti che tu abbia deciso di rimanere in contatto con noi, continuerai a ricevere aggiornamenti utili riguardanti il tuo soggiorno.'
            },
            activate: {
              confirm: 'Grazie per la tua scelta! Siamo lieti che tu abbia deciso di reiscriverti alle comunicazioni. Continuerai a ricevere aggiornamenti utili riguardanti il tuo soggiorno.',
              cancel: 'Grazie per aver aggiornato le tue preferenze, non riceverai comunicazioni relative a questo soggiorno. Se cambiassi idea, potrai aggiornare le tue preferenze in qualsiasi momento.'
            }
          }
        }
    }
};

export default translations;



// WEBPACK FOOTER //
// ./translations/mail_unsubscribe/MailUnsubscribe.js